import React from "react";
import { useFormContext } from "react-hook-form";
import { Stack } from "@mui/material";

import { HubHookFormSelect, UsersHookFormSelect } from "../../../components";
import { PART_STATUSES } from "../../../constants";

const sx = {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: "10px",
};
export const PartDetailsLocation = () => {
  const { getValues } = useFormContext();
  const locationId = getValues("locationId");

  return (
    <Stack sx={sx}>
      <UsersHookFormSelect
        label="Part Manager"
        name="details.managerId"
        locationId={locationId == 3 ? 1 : locationId}
      />
      <HubHookFormSelect
        label="Status"
        name="details.status"
        options={PART_STATUSES}
        required
      />
    </Stack>
  );
};

export default PartDetailsLocation;
